// extracted by mini-css-extract-plugin
module.exports = {"sidebarHeader":"compose-module--sidebarHeader--283665","header":"styles-module--header--0448c1 compose-module--sidebarHeader--283665"};